import React, { useEffect, useState } from 'react';
import BoxStep from '../../../common/BoxStep';
import {
  getCustomDaysSideOrders,
  getMealExchangeDays,
} from '../../../../redux/selectors/orderFormSelector';
import { nanoid } from '@reduxjs/toolkit';
import EmptyImageSideOrder from '../../../../assets/icons/EmptyImageSideOrder';
import Button from '../../../common/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faPlusCircle } from '@fortawesome/pro-regular-svg-icons';
import { faPencil } from '@fortawesome/pro-light-svg-icons';
import { createSideOrdersDayList } from '../../../../redux/actions/orderFormActions';
import { storeSideOrdersSlice } from '../../../../features/chooseSideOrders/chooseSideOrdersSlice';
import SelectSideOrdersModal from './SelectSideOrdersModal';
import { parsePrice } from '../../../../utils';
import { useAppDispatch, useAppSelector } from '../../../../config/hooks';
import { SideOrderT } from '../../../../@types/sideOrder.type';
import { getChooseSideOrdersList } from '../../../../features/chooseSideOrders/chooseSideOrdersSelectors';
import { classNamesUtil } from '../../../../utils/classNamesUtil.util';

type Props = {
  sideOrders: Array<SideOrderT>;
};

const ChooseSideOrders = ({ sideOrders }: Props) => {
  const dispatch = useAppDispatch();

  const chooseSideOrdersList = useAppSelector(getChooseSideOrdersList);
  const customSideOrders = useAppSelector(getCustomDaysSideOrders);
  const customOrderDays = useAppSelector(getMealExchangeDays);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSideOrder, setSelectedSideOrder] = useState<null | SideOrderT>(
    null
  );

  const openModal = (sideOrder: SideOrderT) => {
    setSelectedSideOrder(sideOrder);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (!Object.values(customOrderDays || {}).length) {
      dispatch(createSideOrdersDayList(sideOrders));
    }
    // DO NOT REMOVE
    // eslint-disable-next-line
  }, [dispatch, sideOrders]);

  useEffect(() => {
    if (Object.values(customSideOrders || {}).length) {
      dispatch(storeSideOrdersSlice(customSideOrders));
    }
  }, [customSideOrders, dispatch]);

  return (
    <>
      {isModalOpen && selectedSideOrder && (
        <SelectSideOrdersModal
          chooseSideOrdersList={chooseSideOrdersList}
          isOpen={isModalOpen}
          selectedSideOrder={selectedSideOrder}
          setIsOpen={setIsModalOpen}
          setSelectedSideOrder={setSelectedSideOrder}
        />
      )}

      <BoxStep title="Wybierz dodatki">
        <p className="body-m">
          Dodatki możesz wybrać na każdy dzień lub wybrane dni zamówienia.
        </p>
        {sideOrders.map((sideOrder: SideOrderT) => {
          const {
            defaultPrice,
            description,
            imageUrl,
            name,
            possibleSideOrderId,
          } = sideOrder || {};

          const isSideOrderSelected = Object.values(chooseSideOrdersList).some(
            // TODO ANY
            (item: any) => {
              return Object.values(item).some(
                // TODO ANY
                (sideOrderItem: any) =>
                  sideOrderItem.possibleSideOrderId === possibleSideOrderId &&
                  sideOrderItem.amount
              );
            }
          );

          return (
            <div
              className={classNamesUtil(
                'steps-page__side-orders-page-description',
                {
                  'steps-page__side-orders-page-description--selected':
                    isSideOrderSelected,
                }
              )}
              key={nanoid()}
            >
              <div className="steps-page__side-orders-page-description-wrapper">
                {imageUrl ? (
                  <img
                    alt={name}
                    className="border-radius-default object-fit-contain"
                    height={80}
                    src={imageUrl}
                    width={80}
                  />
                ) : (
                  <EmptyImageSideOrder />
                )}
                <div className="display-flex justify-content-center flex-direction-column flex-1">
                  <div className="label-m display-flex align-items-center">
                    {name}
                  </div>
                  {description && (
                    <div className="body-m display-flex align-items-center spacer-top-4">
                      {description}
                    </div>
                  )}
                </div>
              </div>
              <div className="display-flex flex-direction-column align-items-end spacer-bottom-10">
                <div className="label-m color-primary spacer-bottom-18">
                  {parsePrice(defaultPrice)} zł / dzień
                </div>
                {isSideOrderSelected ? (
                  <div className="display-flex">
                    <Button
                      containerClass="steps-page__side-orders-page-add-button"
                      icon={<FontAwesomeIcon icon={faCheck} />}
                      label="Dodany"
                    />
                    <Button
                      colorBlank
                      containerClass="color-primary"
                      icon={<FontAwesomeIcon icon={faPencil} />}
                      label="Zmień"
                      onClick={() => {
                        openModal(sideOrder);
                      }}
                    />
                  </div>
                ) : (
                  <Button
                    colorBlank
                    containerClass="color-primary"
                    icon={<FontAwesomeIcon icon={faPlusCircle} />}
                    label="Dodaj"
                    onClick={() => {
                      openModal(sideOrder);
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </BoxStep>
    </>
  );
};

export default ChooseSideOrders;
